/**
 * email-signup D3 — the email signup plug-in: a box on a studio's custom website where
 * visitors leave their email, and the studio's Email list in the admin, which it downloads
 * into its own email service. Telify sends nothing to the list. Its switch is `email-list`.
 * It comes with the Shop (Gabriel 2026-10-26: "Shop will be a paid feature and those two
 * included with shop"), and for now it is a custom-site piece only (Gabriel 2026-10-27: "So
 * the email signup is just a custom site feature for now."). Its routes, admin section and
 * piece join this declaration as each is built (tasks 4.2, 5.2, 5.3 and 7.1), so `pnpm
 * plugins:check` and the API's boot check stay green at every step.
 */
import { definePlugin } from './define.js';

export const emailListPlugin = definePlugin({
  id: 'email-list',
  name: 'Email signup',
  description:
    "Puts an email signup box on the studio's custom website and keeps the studio's email list, which it downloads into its own email service. Telify sends nothing to the list.",
  paidAddOn: false,
  includedWith: 'shop',
  feature: 'email-list',
  pieces: ['email-signup'],
  pages: [],
  siteRoutes: {
    prefix: '/api/site/email-list',
    routes: [
      { method: 'POST', url: '/api/site/email-list/ticket' },
      { method: 'POST', url: '/api/site/email-list/signup' },
    ],
  },
  adminRoutes: {
    prefix: '/api/admin/email-list',
    routes: [
      { method: 'GET', url: '/api/admin/email-list' },
      { method: 'POST', url: '/api/admin/email-list/exports' },
      { method: 'DELETE', url: '/api/admin/email-list/:entryId' },
    ],
  },
  adminSections: ['email-list'],
  noticeTypes: [],
  clientMessageTypes: [],
  emailKinds: [],
  services: [],
});
